import { Form, Input, InputNumber } from 'antd'
import { FC } from 'react'

const HiddenMachineCountersFields: FC = () => {
    return (
        <>
            <Form.List name="machineCounters">
                {fields =>
                    fields.map(({ key, name, ...rest }) => (
                        <div key={key} style={{ display: 'none' }}>
                            <Form.Item {...rest} name={[name, 'machineDocumentId']}>
                                <Input />
                            </Form.Item>
                            <Form.Item {...rest} name={[name, 'machineName']}>
                                <Input />
                            </Form.Item>
                            <Form.Item {...rest} name={[name, 'currentCounter']}>
                                <InputNumber />
                            </Form.Item>
                        </div>
                    ))
                }
            </Form.List>

            <Form.Item name="savedMachineCounter" hidden>
                <InputNumber />
            </Form.Item>

            <Form.Item name="initialConsumptionMeters" hidden>
                <InputNumber />
            </Form.Item>
        </>
    )
}

export default HiddenMachineCountersFields